const FlagEUColor = props => (
	<svg height="28" width="28" className="flag-eu" viewBox="0 0 200 200" {...props}>
		<rect width="200" height="200" fill="#003399" />
		<circle fill="#FFCC00" cx="46.23" cy="68.96" r="5.13" transform="translate(-16.27 14.32) rotate(-15)" />
		<circle fill="#FFCC00" cx="153.77" cy="131.04" r="5.13" transform="translate(-28.68 44.26) rotate(-15)" />
		<circle fill="#FFCC00" cx="37.91" cy="100" r="5.13" transform="translate(-59.61 56.1) rotate(-45)" />
		<circle fill="#FFCC00" cx="162.09" cy="100" r="5.13" transform="translate(-23.24 143.9) rotate(-45)" />
		<circle fill="#FFCC00" cx="46.23" cy="131.04" r="5.13" transform="translate(-92.31 141.78) rotate(-75)" />
		<circle fill="#FFCC00" cx="153.77" cy="68.96" r="5.13" transform="translate(47.36 199.64) rotate(-75)" />
		<circle fill="#FFCC00" cx="68.96" cy="153.77" r="5.13" transform="translate(-37.45 23.09) rotate(-15)" />
		<circle
			fill="#FFCC00"
			cx="131.04"
			cy="46.23"
			r="5.13"
			transform="matrix(0.97, -0.26, 0.26, 0.97, -7.5, 35.49)"
		/>
		<circle fill="#FFCC00" cx="100" cy="162.09" r="5.13" transform="translate(-85.32 118.18) rotate(-45)" />
		<circle fill="#FFCC00" cx="100" cy="37.91" r="5.13" transform="translate(2.48 81.82) rotate(-45)" />
		<circle fill="#FFCC00" cx="131.04" cy="153.77" r="5.13" transform="translate(-51.4 240.55) rotate(-75)" />
		<circle fill="#FFCC00" cx="68.96" cy="46.23" r="5.13" transform="translate(6.45 100.87) rotate(-75)" />
	</svg>
);

export default FlagEUColor;
